import { render, staticRenderFns } from "./PrivacyExifWipe.vue?vue&type=template&id=5e89668c&scoped=true"
import script from "./PrivacyExifWipe.vue?vue&type=script&lang=js"
export * from "./PrivacyExifWipe.vue?vue&type=script&lang=js"
import style0 from "./PrivacyExifWipe.vue?vue&type=style&index=0&id=5e89668c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e89668c",
  null
  
)

export default component.exports